import $axios from "../api/accessor";
import { $api } from "../api/api";

export const AttorneyService = {
  async GetAttorney(url? : string) {
    let response = await $axios
      .get(url || $api("get_Attornery"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async PostAttornary(payload: any) {
    try {
      const response = await $axios.post($api("post_Attornery"), payload);
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },

 async UpdateAttornary(id: number | string, payload: any) {
  try {
    const url = $api("Edit_Attornery").replace("{id}", id.toString());
    const response = await $axios.put(url, payload);
    return response;
  } catch (error: any) {
    throw error.response ? error.response.data : error.message;
  }
},



  async DeleteAttornary(id: string | number) {
    try {
      const url = $api(`Delete_Attornery`).replace("{id}", id.toString());
      const response = await $axios.delete(url);
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },
};
